export default __webpack_public_path__ + "static/media/times_now.c27c0da0.png";